module.exports = __webpack_public_path__ + "static/media/emotionalMirror.e2eac7ca.jpg";